import React from "react";
import MoneyCycleChart from "./components/MoneyCycleChart";

// Test data to show the Money Cycle Chart
const testData = {
  currency: "USD",
  income: 5000,
  expenses: 3500, 
  savingsMonthly: 1500,
  passiveIncomeMonthly: 200,
  emergencyFundBalance: 15000,
  totalDebtPaymentMonthly: 800,
};

const MoneyCyclePreview = () => {
  return (
    <div style={{ padding: '20px', backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '10px' }}>
            Money Cycle Chart Preview
          </h1>
          <p style={{ color: '#64748b' }}>
            Exact replica of the Money Cycle diagram with responsive SVG design
          </p>
        </div>
        
        <MoneyCycleChart {...testData} />
        
        <div style={{ marginTop: '30px', padding: '20px', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <h3 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '15px' }}>Test Data Used:</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
            <div>
              <strong>Monthly Income:</strong> $5,000
            </div>
            <div>
              <strong>Monthly Expenses:</strong> $3,500
            </div>
            <div>
              <strong>Monthly Savings:</strong> $1,500
            </div>
            <div>
              <strong>Passive Income:</strong> $200/month
            </div>
            <div>
              <strong>Emergency Fund:</strong> $15,000 (4.3 months)
            </div>
            <div>
              <strong>Debt Payments:</strong> $800/month
            </div>
          </div>
          <div style={{ marginTop: '15px', padding: '10px', backgroundColor: '#dcfce7', borderRadius: '6px' }}>
            <strong>Result:</strong> This user is in the <span style={{ color: '#16a34a', fontWeight: 'bold' }}>GAINS</span> state 
            (Income $5,000 - Expenses $3,500 = +$1,500 surplus), so the green "Gains" path is highlighted 
            with arrows flowing to Savings → Emergency Fund & Investments → Passive Income → Abundance.
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoneyCyclePreview;